"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _truncate = _interopRequireDefault(require("lodash/truncate"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _i18n = require("../../../i18n");
var _constants = require("../constants");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PanelMessage = _ref => {
  let {
    i18nKey
  } = _ref;
  const {
    reportTitle
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const {
    T
  } = (0, _i18n.useTranslation)();
  const truncatedReportTitle = (0, _truncate.default)(reportTitle, {
    length: _constants.TRUNCATED_TITLE_LENGTH
  });
  return /*#__PURE__*/_react.default.createElement(StyledMessage, null, T.translate(i18nKey, {
    reportTitle: truncatedReportTitle
  }));
};
const StyledMessage = (0, _styledComponents.default)(_styledComponents.default.p(_alloyReactTheme.default.typography.bodyLarge))`
  text-align: center;
  padding-top: 24px;
  margin-bottom: 20px;
`;
PanelMessage.propTypes = {
  i18nKey: _propTypes.default.string.isRequired
};
var _default = exports.default = PanelMessage;